import { Routes } from '@angular/router';

export const manageUsersRoutes: Routes = [
  {
    path: 'manage-users',
    children: [
      { path: '', redirectTo: 'users-list', pathMatch: 'full' },
      {
        path: 'users-list',
        loadComponent: () =>
          import('./pages/users-list/users-list').then((m) => m.UsersList),
      },
      {
        path: 'create-users',
        loadComponent: () =>
          import('./pages/create-users/create-users').then((m) => m.CreateUsers),
      },
    ],
  },
];
